import { useLocation,Navigate } from "react-router-dom";
import WexonLayout from "../layout/Layout";

export default function RequireAuth(){

  let location=useLocation()

  if(localStorage.getItem('Authorization')){return ( <WexonLayout></WexonLayout>);}
  else return (<Navigate to='/login' state={{from:location}} replace ></Navigate>)
}